export class RandonString {
    constructor() {}

    static genereteId() {
        return (
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
        );
    }

    static generatePassword() {
        return Math.random().toString(36).substring(2, 12);
    }
}
